goog.provide('el8.tourguide.Slide');

el8.tourguide.Slide = function(opts) {
    this._showFn = opts.showFn || null;
    this._quickShowFn = opts.quickShowFn || null;
    this._hideFn = opts.hideFn || null;
    this._refreshFn = opts.refreshFn || null;
    this._visorHeight = opts.visorHeight || 0;
    this._navTemplateFn = opts.navTemplateFn;
    this._name = opts.name || null;
    this._navCaption = opts.navCaption || null;
    this._addOverlay = (opts.addOverlay === true); // defaults false
    this._eventToSlideNameMap = opts.eventToSlideNameMap || null;
};

el8.tourguide.Slide.prototype.show = function(doQuick) {
    if (this._addOverlay) {
        this._overlay = $('<div class="tour-overlay tourGuideOverlay">');
        this._overlay.css({
            'width': '100%',
            'position': 'fixed',
            'left': '0px',
            'top': '0px',
            'background-color': 'black'
        });
        this.setOverlayHeight();
        $('body').prepend(this._overlay);
    }
    if (doQuick) {
        if (this._quickShowFn) { 
            this._quickShowFn(); 
        } else if (this._showFn) {
            this._showFn();
        }
    } else {
        if (this._showFn) { this._showFn(); }
    }
    return this;
};

el8.tourguide.Slide.prototype.hide = function() {
    if (this._hideFn) { this._hideFn(); }
    if (this._overlay) { this._overlay.remove(); }
    return this;
};

el8.tourguide.Slide.prototype.setOverlayHeight = function() {
    if (!this._overlay) { return; }
    var windowHeight = $(window).height();
    this._overlay.height(windowHeight - this._visorHeight);
    this._overlay.offset({'top': this._visorHeight});
};

el8.tourguide.Slide.prototype.getNavTemplateFn = function() {
    return this._navTemplateFn;
};

el8.tourguide.Slide.prototype.getName = function() {
    return this._name || '';
};

el8.tourguide.Slide.prototype.getEventToSlideNameMap = function() {
    return this._eventToSlideNameMap;
};

el8.tourguide.Slide.prototype.getNavCaption = function() {
    return this._navCaption;
};

el8.tourguide.Slide.prototype.getRefreshFn = function() {
    return this._refreshFn;
};
